jQuery(document).ready(function ($) {
  // const maxSelection = 2;
  // const selectedCheckboxes = [];

  // if (jQuery('.HorizontalList--spacingTight .HorizontalList__Item input.SizeSwatch__Radio:checked').length > 0) {
  //   selectedCheckboxes.push(jQuery('.HorizontalList--spacingTight .HorizontalList__Item input.SizeSwatch__Radio:checked'));
  // }

  // jQuery('.HorizontalList--spacingTight .HorizontalList__Item input.SizeSwatch__Radio').change(function () {
  //   const $checkbox = jQuery(this);

  //   if ($checkbox.is(':checked')) {
  //     selectedCheckboxes.push($checkbox);

  //     if (selectedCheckboxes.length > maxSelection) {
  //       const firstSelected = selectedCheckboxes.shift(); // remove first selected
  //       firstSelected.prop('checked', false);
  //     }
  //   } else {
  //     // If unchecked manually, remove it from the array
  //     selectedCheckboxes = selectedCheckboxes.filter(cb => cb[0] !== this);
  //   }
  // });

  $("#paired-product-select").select2({
    templateResult: formatOption,
    templateSelection: formatOption,
    width: "100%",
  });

  function formatOption(state) {
    if (!state.id) return state.text;
    var img = $(state.element).data("image");
    var price = $(state.element).data("price");
    return $(
      '<span class="cstm-item-list"><img src="' +
        img +
        '">' +
        '<div class="cstm-text">' +
        state.text +
        "<p>" +
        price +
        "</p>" +
        "</div>" +
        "</span>"
    );
  }

  jQuery('[action="/cart/add"] [type="submit"]').on("click", function () {
    var pairedId = jQuery("#paired-product-select").val();
    var pairedTitle = jQuery("#paired-product-select option:selected").attr(
      "data-title"
    );
    var mainTitle = jQuery("#paired-product-select").attr("data-product-title");

    if (pairedId) {
      var itemIndex = 2;
      jQuery("#paired-product-hidden-inputs").html(`
        <input type="hidden" name="items[${itemIndex}][id]" value="${pairedId}">
        <input type="hidden" name="items[${itemIndex}][quantity]" value="1">
        <input type="hidden" name="properties[Paired Product]" value="${pairedTitle}">
        <input type="hidden" name="items[${itemIndex}][properties][Paired with]" value="${mainTitle}">
        `);

      if (jQuery("#paired-variant-product").html()) {
        jQuery("#paired-variant-product").append(`
          <input type="hidden" name="items[1][properties][Paired Product]" value="${pairedTitle}">
        `);
      }
    } else {
      jQuery("#paired-product-hidden-inputs").html("");
    }
  });

  $("#paired-product-select").on("select2:select", function (e) {
    var updatedPrice = parseInt(jQuery('[name="main-variant-price"]').val());
    updatedPrice +=
      jQuery('[name="addon-variant-price"]').length > 0
        ? parseInt(jQuery('[name="addon-variant-price"]').val())
        : 0;
    updatedPrice += jQuery("#paired-product-select").val()
      ? parseInt(
          jQuery("#paired-product-select")
            .find("option:selected")
            .attr("data-raw-price")
        )
      : 0;
    jQuery(".ProductMeta__PriceList .ProductMeta__Price.Price").html(
      formatMoney(updatedPrice)
    );
  });
});

function formatMoney(cents) {
  var price = (cents / 100).toFixed(2);
  return window.money_format.replace("{{amount}}", price);
}
